import Keycloak from "keycloak-js";
import { getTokenFromStorage } from "./utils/helpers";

const initConfigs = {
  url: process.env.REACT_APP_KEYCLOAK_URL || "",
  realm: process.env.REACT_APP_KEYCLOAK_REALM || "",
  clientId: process.env.REACT_APP_KEYCLOAK_CLIENT_ID || ""
};

const initOptions = {
  onLoad: "check-sso"
};

export const keycloak = new Keycloak(initConfigs);

export const KeycloakInit = (app) => {
  keycloak
    .init(initOptions)
    .then((auth) => {
      if (auth) {
        setInterval(() => {
          keycloak
            .updateToken(70)
            .then(() => {})
            .catch((err) => {
              console.log("KeycloakInit", err);
            });
        }, 30000);
      }
    })
    .catch((err) => {
      console.log("KeycloakInit catch: ", err);
    })
    .finally(() => {
      app();
    });
};

export const PreferredName = () => {
  return keycloak.idTokenParsed?.preferred_username ?? "";
};

export const PreferredEmail = () => {
  return keycloak.idTokenParsed?.email ?? "";
};

export const AccessToken = () => {
  return keycloak.token ?? getTokenFromStorage() ?? "";
};

export const Logout = () => {
  return keycloak.authenticated && keycloak.logout();
};

export const HasRole = (role) => {
  return keycloak.hasResourceRole(role, "prm-dev");
};

